import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { ConcorrenteSelectComponent } from './concorrente-select.component';

@NgModule({
  imports: [SharedModule],
  declarations: [ConcorrenteSelectComponent],
  exports: [ConcorrenteSelectComponent],
})
export class ConcorrenteSelectModule {}
